import { JSX } from 'react';
import { ComponentDynamicSvgArgs } from '../../components/types/component-dynamic-svg.type';

// Cutout dimensions (must match component data cutout)
const CUTOUT_W = 14.75;
const CUTOUT_D = 17.125;

// Faucet hole position (top center, above the cutout)
const FAUCET_X = CUTOUT_W / 2;
const FAUCET_R = 1.375 / 2;
const FAUCET_CY = -0.75;

// Distance from faucet center to cutout edge (2")
const FAUCET_TO_EDGE = 2;
const LINE_END_Y = FAUCET_CY + FAUCET_TO_EDGE;

export const c1sink1618 = {
	item: ({ x, y, opacity = 1, fontSize }: ComponentDynamicSvgArgs): JSX.Element => {
		const xPos = x ?? -(CUTOUT_W / 2);
		const yPos = y ?? -(CUTOUT_D / 2);

		return <g fill="none" stroke="black" strokeWidth="0.125" transform={`translate(${xPos}, ${yPos})`} opacity={opacity}>
			{/* Faucet hole */}
			<circle cx={FAUCET_X} cy={FAUCET_CY} r={FAUCET_R} fill="none"/>
			{/* Centerline from faucet center through cutout */}
			<line x1={FAUCET_X} y1={FAUCET_CY} x2={FAUCET_X} y2={LINE_END_Y}/>

			{/* Distance label */}
			<text x={FAUCET_X + FAUCET_R + 0.4} y={((FAUCET_CY + LINE_END_Y) / 2) + 0.3} fontSize={fontSize} textAnchor="start" fill="black" stroke="none">
				2&quot;
			</text>

			{/* Faucet hole diameter label */}
			<text x={FAUCET_X} y={FAUCET_CY - FAUCET_R - 0.4} fontSize={fontSize} textAnchor="middle" fill="black" stroke="none">
				1.375&quot; D
			</text>
		</g>;
	},
	cutout: (): null => {
		return null;
	}
};
